import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import Footer from '@Components/Footer';

import NoAlerts from './AlertsComponents/NoAlerts';
import GroupsList from './AlertsComponents/GroupsList';

import './Alerts.scss';

export default function Alerts(props) {
  const { groupsIds } = props;
  const result = groupsIds && (groupsIds.count() ? <GroupsList groupsIds={groupsIds} /> : <NoAlerts />);

  return (
    <div className="alerts-page__container alerts-container">
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div id="main-content" className="alerts-content" tabIndex="0" aria-labelledby="alerts-title">
        <section className="rx-list-wrapper">
          <div className="header-container--border-bottom u-els-padding-top-1x u-els-padding-bottom-1x">
            <h1 id="alerts-title" className="alerts-heading u-els-font-size-h3 rx-left-gutter">
              Alerts
            </h1>
          </div>
          <div className="alerts-items-wrapper rx-list-wrapper rx-left-gutter rx-right-gutter">{result}</div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

Alerts.propTypes = {
  groupsIds: PropTypes.instanceOf(List),
};
